import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
	LimitedTextField,
	SidePanel,
	SidePanelContent,
	OptionsPanelContainer,
} from "../../../../../../../../../common/components";
import { translate } from "../../../../../../../../../common/providers";
import { setDisableKeyEvents } from "../../../../../../../../../common/slice";
import styles from "../../../HelperText.module.css";

const CommentAddSidePanel = ({
	oldComment = null,
	onActive = null,
	onAddComment,
	onClose,
	onEditComment,
	open = false,
	reqId = 0,
}) => {
	const [newComment, setNewComment] = useState("");
	const dispatch = useDispatch();

	useEffect(() => {
		if (oldComment) {
			setNewComment(oldComment.comment);
		} else {
			setNewComment("");
		}
	}, [oldComment, open]);

	const handleComment = (value) => {
		setNewComment(value);
	};
	const handleClick = () => {
		if (newComment.length > 1) {
			if (oldComment) {
				onEditComment(newComment, oldComment);
			} else {
				onAddComment(newComment);
			}
		}
	};
	return (
		<SidePanel
			disableBackdropClick
			disableEscapeKeyDown
			open={open}
			size={38}
			onActive={onActive}
			onClose={onClose}
		>
			<SidePanelContent
				title={translate("smart-review.cmp-details.option-panel.title", { reqId })}
				onClose={onClose}
			>
				<OptionsPanelContainer
					buttonText={translate("common:btn.save")}
					buttonTextSecondary={translate("common:btn.cancel")}
					disabledPrimaryButton={newComment.length < 2}
					title={translate("smart-review.cmp-details.option-panel.comments")}
					onClick={handleClick}
					onClickSecondary={onClose}
				>
					<LimitedTextField
						fullWidth
						multiline
						maxLength={512}
						placeholder={translate(
							"smart-review.cmp-details.option-panel.comment-tab.add-your-requirement"
						)}
						rows={4}
						value={newComment}
						onBlur={() => dispatch(setDisableKeyEvents(false))}
						onChange={handleComment}
						onFocus={() => dispatch(setDisableKeyEvents(true))}
					/>
					<span className={styles.helperText}>
						{translate("smart-review.cmp-details.option-panel.comment-tab.helper-text")}
					</span>
				</OptionsPanelContainer>
			</SidePanelContent>
		</SidePanel>
	);
};

export default CommentAddSidePanel;
